<template>
  <div class="hello">
    <section class="info">
      <div class="head">当前信息</div>
      <div v-show="data.length!=0">
        <p>{{data.province_name}}丨{{data.city_name}}丨{{data.county_name}}</p>
        <p>{{data.school}}</p>
        <p>年级:{{data.grade_name}}</p>
        <p>班级:{{data.class}}</p>
        <button class="edit" @click="showdialogVisible">
          修改信息
        </button>
      </div>
      <div v-show="data.length==0">

        <button class="edit" style="margin-top: 40px;" @click="showdialogVisible">
          添加信息
        </button>
      </div>
    </section>

  </div>
</template>

<script>
  export default {
    data() {
      return {

        user: []
      }
    },

    props: {
      data: {
        type: Array,
        required: true
      }
    },
    created() {
      // this.$http.userExamInfo().then(res => {
      //   this.data = res.data.last_score
      // })
    },
    mounted() {

    },
    methods: {
      sing() {

        console.log('我是子组件的方法');

      },
      showdialogVisible() {
        this.$emit('showdialogVisible', 111)
      }
    }
  }
</script>

<style scoped lang="scss">
  button {
    background-color: #FFFFFF;
    color: #C10B17;
    border: none;
    width: 80%;
    height: 33px;
    border: 1px solid #C10B17;
    border-radius: 6px;
  }

  .info {
    min-width: 175px;
    min-height: 250px;
    background: #FFFFFF;
    border-radius: 10px;
    margin-top: 18px;
    border: 1px solid #EDEDED;
    text-align: center;
    padding-bottom: 20px;



    p {
      width: 100%;

      margin: 20px 0px 20px 0px;
    }

    .head {
      height: 60px;
      background: #C10B17;
      border-radius: 10px;
      line-height: 60px;
      color: #FFFFFF;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }

    .score {

      margin-right: 10px;

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/me/growthInfo.vue